(function ($, Drupal) {

	/**
   * If there is a video in the modal auto-play it and pause it on close
   */
	Drupal.behaviors.modalVideoBehavior = {
		attach: function attach() {
			$('#drupal-modal').one('shown.bs.modal', function () {
				// Disable the play button until the video loads and it's ready to play (3 seconds max)
				$('#drupal-modal .video-js').find('.vjs-big-play-button').attr('disabled', true);
				setTimeout(function enablePlayButton(){
					$('#drupal-modal .video-js').find('.vjs-big-play-button').attr('disabled', false);
				}, 3000);

				// Play Video
				videojs($('#drupal-modal .video-js').attr('id'), null, function(){
					this.on('loadedmetadata', function(){
						$('#drupal-modal .video-js').find('.vjs-big-play-button').attr('disabled', false);
						this.play();
					});
				});
			});

			// Pause Video
			$('#drupal-modal').one('hidden.bs.modal', function () {
				videojs($('#drupal-modal .video-js').attr('id')).pause();
			});
		}
	};

	/**
   * If there is a 'videolanding' query string, scroll to the video or playlist and auto-play
   *
   * @type {{attach: attach, getParameterByName: getUrlParameterByName}}
   */
	Drupal.behaviors.brightcoveMarketing = {
		attach: function attach() {
			const videoLandingQueryString = 'videolanding';
			const videoLandingId = this.getUrlParameterByName(videoLandingQueryString, window.location.href);

			if (videoLandingId !== null && window.location.href.indexOf('#videoplaying') === -1) {
				const brightcoveVideoField = '.field--name-field-brightcove-video, .field--name-field-product-video';
				const brightcovePlaylistField = '.field--name-field-video-player-component .video-js';
				const $videoDiv = $(brightcoveVideoField).find(`div[data-video-id='${videoLandingId}']`);
				const $bcPlaylist = $(brightcovePlaylistField);
				const $bcPlaylistId = $bcPlaylist.attr('id');

				// Autoplay embedded videos
				if ($videoDiv.length) {
					const $bcVideo = `${$videoDiv.attr('id')}_html5_api`;

					$('html, body').animate({
						scrollTop: $videoDiv.offset().top - 200
					}, 1000);

					videojs($bcVideo).ready(function() {
						let bcPlayer = this;

						bcPlayer.play();
					});
				}
				else {
					// Autoplay modal videos
					const modalsCssSelector = 'a[href*="brightcove_video"][data-dialog-type="modal"]';
					let modalVideos = $(modalsCssSelector);

					if (modalVideos.length) {
						$(modalsCssSelector).each(function(i, element) {
							$.post(`${element.href}?_wrapper_format=drupal_modal`)
								.then(function(res){
									const brightcove_id = $(res[2].data).data('video-id').toString();

									// If you find a matching brightcove video
									if (brightcove_id === videoLandingId) {
										// Play video
										window.location.hash = 'videoplaying';
										$(element).click();

										// Scroll to the video
										$('html, body').animate({
											scrollTop: $(element).offset().top - 200
										}, 1000);
									}
								});
						});
					}

					// Autoplay video in the playlist.
					setTimeout(function() {
						if (window.location.hash.indexOf('videoplaying') === -1) {
							videojs($bcPlaylistId).ready(function() {
								let bcPlaylist = this;

								const video = bcPlaylist.catalog.data.videos.filter((video) => video.id == videoLandingId)[0];
								// Load the video object into the player and play it
								if(video){
									window.location.hash = 'videoplaying';
									bcPlaylist.catalog.load(video);
									bcPlaylist.play();
								}

								$('html, body').animate({
									scrollTop: $bcPlaylist.offset().top - 100
								}, 1000);
							});
						}
					}, 1000);
				}
			}
		},
		getUrlParameterByName: function (name, url) {
			if (!url) {
				url = window.location.href;
			}
			name = name.replace(/[\[\]]/g, '\\$&');
			const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
			const results = regex.exec(url);
			if (!results || !results[2]) {
				return null;
			}
			return decodeURIComponent(results[2].replace(/\+/g, ' '));
		},
		getVideoIndexFromPlaylistById: (videos, id) =>
			videos.map(video => video.id).indexOf(id)
	};

})(jQuery, Drupal);
